import React, { useState, useRef } from "react";
import { Modal, Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
import Webcam from "react-webcam";
import { toast,Toaster } from "react-hot-toast";
import { BASE_URL } from "../../../../components/BaseUrl";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { decryptToken } from "../../../../Utlis/Encryption";
const videoConstraints = {
  width: 400,
  height: 250,
  facingMode: "user", // front camera
};

const FaceScanModal = ({ open, onClose, onContinue }) => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [faceFileId, setFaceFileId] = useState(null); // uploaded image URL
  const [uploading, setUploading] = useState(false);
  const { t,i18n } = useTranslation();
 const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [cameraReady, setCameraReady] = useState(false);
  // 🔄 Reset modal state when opened
  React.useEffect(() => {
    if (open) {
      setValidationError("");
      setCapturedImage(null);
      setFaceFileId(null);
          setValidationFailed(false);
      setCameraReady(false);
      console.log("📸 Face scan modal opened - ready for fresh capture");
    }
  }, [open]);

const [validationError, setValidationError] = useState("");
const [validationFailed, setValidationFailed] = useState(false);



const validateFace = async (imageUrl) => {
  try {
    const res = await fetch(`${BASE_URL}/attendance/validate-face`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        selfie: imageUrl,
      }),
    });

    const data = await res.json();
    console.log("Face validation response:", data);

    const currentLang = i18n.language;

    // ✅ If valid
    if (res.ok && data?.data?.valid === true) {
      setValidationError("");
      toast.success(
        currentLang === "es"
          ? data?.message_es
          : data?.message_en
      );
      return true;
    }

    // ❌ If invalid → ALWAYS show custom message
    setValidationError(
      currentLang === "es"
        ? "Su rostro no coincide con el escaneo facial registrado; por lo tanto, este registro será considerado inválido."
        : "Your face does not match the registered face scan; therefore, this punch will be considered an invalid punch."
    );

    return false;

  } catch (err) {
    const currentLang = i18n.language;

    setValidationError(
      currentLang === "es"
        ? "Su rostro no coincide con el escaneo facial registrado; por lo tanto, este registro será considerado inválido."
        : "Your face does not match the registered face scan; therefore, this punch will be considered an invalid punch."
    );

    return false;
  }
};

  // ✅ Capture + upload face image
  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
    setUploading(true);

    try {
      // Convert base64 → Blob
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const formData = new FormData();
      formData.append("image", blob, "face.jpg"); // ✅ must be "image"

      console.log("📤 Uploading to:", `${BASE_URL}/upload/image`);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData, // ❌ no headers
      });

      const rawText = await res.text();
      console.log("📥 Raw server response:", rawText);

      let data;
      try {
        data = JSON.parse(rawText);
      } catch (err) {
// toast.error(t("faceScan.invalidJson"));
        console.error("❌ JSON parse failed:", err);
        setUploading(false);
        return;
      }

      if (!res.ok || data.error) {
      //  toast.error(t("faceScan.uploadFailed"));
        console.error("❌ Upload failed:", data.message || "Server error");
        setUploading(false);
        return;
      }

      if (data.data?.url) {
        console.log("✅ Face image uploaded successfully:", data.data.url);
        setFaceFileId(data.data.url);
// toast.success(t("faceScan.uploadSuccess"));
      } else {
// toast.error(t("faceScan.serverError"));
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
// toast.error(t("faceScan.noUrl"));
    } finally {
      setUploading(false);
    }
  };

// POST `${BASE_URL}/face/detect-face` — disabled; uncomment when detect-face API should run again.
// const verifyFace = async (imageUrl) => {
//   console.log("🔍 verifyFace() CALLED with URL:", imageUrl);
//
//   try {
//     const blob = await fetch(imageUrl).then((res) => res.blob());
//
//     const formData = new FormData();
//     formData.append("image", blob, "face.jpg");
//
//     const res = await fetch(`${BASE_URL}/face/detect-face`, {
//       method: "POST",
//       body: formData,
//     });
//
//     const rawText = await res.text();
//     let data;
//     try {
//       data = JSON.parse(rawText);
//     } catch (err) {
//       toast.error("Invalid server response");
//       return { success: false };
//     }
//
//     // ❗ Your backend reports detection using: data.data.hasFace
//     if (data?.data?.hasFace === true) {
//       toast.success(t("face_detected_success"));
//       return { success: true };
//     }
//
//     // ❌ No face found — show backend message
//     toast.error(t("face_not_detected_retry"));
//     return { success: false };
//
//   } catch (err) {
//     console.log("❌ API ERROR:", err);
//     // toast.error("Face detection failed");
//     return { success: false };
//   }
// };




const currentLang = i18n.language;

  return (
    <>
      <Toaster/>
    <Modal open={open} onClose={onClose}>
    
        <Box
    sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",     // ★ centers vertically
      p: 2,
    }}
  >
      <Box
        sx={{
                  borderRadius: 2,

          bgcolor: "white",
          p: 2,
           maxWidth: 650,
        width: "100%",
        maxHeight: "90vh",       // ★ equal top/bottom breathing space
        overflowY: "auto",       // ★ scroll when screen small
        position: "relative"

        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#333",

          }}
        >
          <CloseRoundedIcon />
        </IconButton>
        <Typography sx={{
          color: "#2C384C", fontSize: "26px", fontWeight: 600, textAlign: "center", fontFamily: 'Poppins, sans-serif',
        }}>{t("faceScanModal.title")}</Typography>
        <p style={{
          fontSize: "14px", color: "#8B8D97", textAlign: "center", fontFamily: 'Poppins, sans-serif',
        }} >{t("faceScanModal.subtitle")}</p>

        {!capturedImage ? (
          <Box sx={{ position: "relative", width: "100%", minHeight: 250 }}>
            {!cameraReady && (
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "#F5F5F5",
                  borderRadius: 2,
                }}
              >
                <CircularProgress size={32} sx={{ color: "#006EC2" }} />
              </Box>
            )}
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              onUserMedia={() => setCameraReady(true)}
              onUserMediaError={() => setCameraReady(true)}
              style={{ width: "100%", borderRadius: 8, display: cameraReady ? "block" : "none" }}
            />
          </Box>
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{ width: "100%", borderRadius: 8 }}
          />
        )}


        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>

        </Box>
        {validationError && (
  <Typography
    sx={{
      color: "red",
      fontSize: "14px",
      mt: 2,
      textAlign: "center",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {validationError}
  </Typography>
)}
        <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "center", alignItems: "center" }}>

          {!capturedImage ? (
            <Button
              variant="outlined"
              onClick={capture}
              disabled={uploading}
              startIcon={uploading ? <CircularProgress size={16} /> : null}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "42px"
              }}
            >
              {uploading ? t("faceScanModal.uploading") : t("faceScanModal.capture")}
            </Button>
          ) : (
            <Button
              variant="outlined"
              onClick={() => {
                setCapturedImage(null);
                setFaceFileId(null);
              }}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "42px"
              }}
            >
              {t("faceScanModal.retake")}

            </Button>
          )}


          <Button
  variant="contained"
  disabled={!faceFileId}


//   onClick={async () => {
//   console.log("📤 Passing face_file_id:", faceFileId);

//   // 1️⃣ Detect face FIRST
//   const detectResult = await verifyFace(faceFileId);


//   // Comment this block for testing
//   // ================================
//   // if (!detectResult.success) {
//   //   console.log("❌ Face not detected — stopping flow");
//   //   return;
//   // }
//   // ================================

//   // 2️⃣ Validate face
//   const isValid = await validateFace(faceFileId);

//   if (!isValid) {
//     console.log("❌ Face validation failed — waiting 1.5s");

//     setTimeout(() => {
//       onContinue({ face_file_id: faceFileId });
//     }, 1500);

//     return;
//   }

//   // ✅ All good → Continue immediately
//   onContinue({ face_file_id: faceFileId });
// }}

onClick={async () => {
  console.log("📤 Passing face_file_id:", faceFileId);

  // If already failed once → allow navigation
  if (validationFailed) {
    onContinue({ face_file_id: faceFileId });
    return;
  }

  // 1️⃣ Detect face — skipped while `/face/detect-face` is commented out (see verifyFace above).
  // const detectResult = await verifyFace(faceFileId);
  // if (!detectResult.success) return;

  // 2️⃣ Validate face
  const isValid = await validateFace(faceFileId);

  if (!isValid) {
    setValidationFailed(true);   // 👈 allow next click to continue
    return;
  }

  // ✅ Valid → move normally
  onContinue({ face_file_id: faceFileId });
}}

  sx={{
    fontSize: 15,
    textTransform: "none",
    borderRadius: "5px",
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "#006EC2",
    color: "#fff",
    px: 4,
    py: 1,
    height: "42px",
    "&:hover": { backgroundColor: "#005bb5" },
  }}
>
  {t("faceScanModal.continue")}
</Button>


        </Box>

      </Box>
      </Box>
    </Modal>
    </>
  );
};

export default FaceScanModal;




